var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectAnswerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#4BFF5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40118 11.5881C7.44433 11.5724 7.48438 11.5492 7.51951 11.5197L13.0376 6.876L12.5998 6.35571L7.35796 10.7669L5.57041 7.21182L4.96289 7.51729L6.88254 11.3351C6.92258 11.4147 6.98395 11.4816 7.05981 11.5284L7.10815 11.5582C7.19612 11.6125 7.30408 11.6235 7.40118 11.5881Z",
    fill: "#021A04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectAnswerIcon);
export default __webpack_public_path__ + "static/media/CorrectAnswerIcon.9ac06f3962766e8899c6e49395341c51.svg";
export { ForwardRef as ReactComponent };